import { useCallback } from 'react';
import { Linking, Platform } from 'react-native';
import { deepLinkToSubscriptions, showManageSubscriptionsIOS, } from 'utils/packages/iap';
import { useAppStore } from 'store/hooks';
import { bundleId } from '../../../constants';
const useOpenManageAppStoreSubscription = () => {
    const reduxStore = useAppStore();
    const manageSubscription = useCallback(async () => {
        const { productId, store } = reduxStore.getState().user.user.emmaProStatus;
        if (store === 'google') {
            if (Platform.OS === 'android') {
                await deepLinkToSubscriptions({
                    skuAndroid: productId || '',
                    packageNameAndroid: bundleId,
                });
            }
            else {
                await Linking.openURL(`https://play.google.com/store/account/subscriptions?package=${bundleId}&sku=${productId || ''}`);
            }
        }
        else if (store === 'apple') {
            if (Platform.OS === 'ios') {
                try {
                    await showManageSubscriptionsIOS();
                }
                catch {
                    await deepLinkToSubscriptions();
                }
            }
            else {
                await deepLinkToSubscriptions();
            }
        }
    }, []);
    return manageSubscription;
};
export default useOpenManageAppStoreSubscription;
